export default (
  form,
  getChargeFrom,
  providerTypes,
  frequencyTypes,
  userPin,
) => {
  const data = {
    ...form,
    charge_frequency:
      form?.charge_from_wallet === 'individual_wallet' ||
      form?.charge_per_category === 'group_member'
        ? frequencyTypes?.[0]
        : form?.charge_frequency,
    get_charge_from: form?.get_charge_from,
    charge_per_category:
      form?.charge_from_wallet === 'individual_wallet'
        ? undefined
        : form?.charge_per_category,
    wallet_providers: form?.wallet_providers,
    password: userPin,
    status:
      form?.charge_from_wallet === 'individual_wallet'
        ? 'inactive'
        : form.status || undefined,
  };

  return data;
};
